// Map API colors to CSS classes
const getColorClass = (colorName: string | null | undefined): string => {
    switch (colorName) {
        case 'green': return 'bg-brand090';
        case 'darkgreen': return 'bg-brand110';
        case 'darkblue': return 'bg-focus110';
        case 'lightblue': return 'bg-focus';
        case 'yellow': return 'bg-interactive110';
        case 'teal': return 'bg-highlight090';
        case 'orange': return 'bg-attention';
        case 'red': return 'bg-error';
        default: return 'bg-transparent';
    }
}

interface TableLegendRowProps {
    color: string | null | undefined;
    text: string | null | undefined;
}
//TODO: go to other component
const TableLegendRow = ({ color, text }: TableLegendRowProps) => { 
    return (
        <div data-testid="h2h-table-legend-row" className='flex flex-row justify-start items-center gap-[3.5px] w-full max-w-full min-w-0'>
            <div data-testid="h2h-table-legend-row-color" className={`w-[10px] h-[10px] rounded-[2px] shrink-0 ${getColorClass(color)}`}
            />
            <div data-testid="h2h-table-legend-row-text" className='text-[12px] leading-[16px] font-robotoRegular font-normal text-monoX dark:text-monoY truncate min-w-0 flex-1'>
                {text}
            </div>
        </div>
    )
}

interface TableLegendProps {
    colorLegend?: Array<{
        color?: string | null | undefined;
        label?: string | null | undefined;
        description?: string | null | undefined;
    }>;
}

const TableLegend = ({ colorLegend }: TableLegendProps) => {
    // If we have colorLegend, show it, data should come from API
    if (colorLegend) {
        return (
            <div data-testid="h2h-table-legend" className='flex flex-col justify-start items-start gap-[8px] px-[16px] sm351:w-[319px] w-full max-w-full mb-[32px]'>
                {colorLegend.map((color, index) => (
                    <TableLegendRow key={index} color={color.color} text={color.label || color.description || ''} />
                ))}
            </div>
        )
    }
}

export default TableLegend;